import React from 'react'
import PropTypes from 'prop-types'
import { TextContainer, TextField, Stack } from '../..'
import * as translationService from './../../../services/translationService'

export default function AddressField(props) {
  const { street, number, box, zip, city, countryId } = props.address

  return (
    <TextContainer>
      <div>
        <Stack distribution="fill">
          <TextField
            label={translationService.t('address.street')}
            name="currentResidenceAddress.street"
            id="currentResidenceAddress.street"
            value={street}
            onChange={props.onChange}
          />
          <TextField
            label={translationService.t('address.number')}
            name="currentResidenceAddress.number"
            id="currentResidenceAddress.number"
            value={number}
            onChange={props.onChange}
          />
          <TextField
            label={translationService.t('address.box')}
            name="currentResidenceAddress.box"
            id="currentResidenceAddress.box"
            value={box}
            onChange={props.onChange}
          />
        </Stack>
      </div>
      <div>
        <Stack distribution="fill">
          <TextField
            label={translationService.t('address.zipcode')}
            name="currentResidenceAddress.zip"
            id="currentResidenceAddress.zip"
            value={zip}
            onChange={props.onChange}
          />
          <TextField
            label={translationService.t('address.city')}
            name="currentResidenceAddress.city"
            id="currentResidenceAddress.city"
            value={city}
            onChange={props.onChange}
          />
        </Stack>
      </div>
      <TextField
        label={translationService.t('address.country')}
        name="currentResidenceAddress.countryId"
        id="currentResidenceAddress.countryId"
        value={countryId}
        onChange={props.onChange}
      />
    </TextContainer>
  )

  // return (
  //   <div className='row'>
  //     <div className='col-md-6 col-12'>
  //       <FormGroup>
  //         <Label for='street'>Straat</Label>
  //         <Input required type='text' name='streetname' id='street' value={street} onChange={props.onChange} />
  //       </FormGroup>
  //     </div>
  //     <div className='col-md-3 col-6'>
  //       <FormGroup>
  //         <Label for='number'>Nummer</Label>
  //         <Input required type='text' name='street_number' id='number' value={number} onChange={props.onChange} />
  //       </FormGroup>
  //     </div>
  //     <div className='col-md-3 col-6'>
  //       <FormGroup>
  //         <Label for='box'>Bus</Label>
  //         <Input type='text' name='box' id='box' value={box} onChange={props.onChange} />
  //       </FormGroup>
  //     </div>
  //     <div className='col-md-4 col-12'>
  //       <FormGroup>
  //         <Label for='zip'>Postcode</Label>
  //         <Input required type='text' name='zip' id='zip' value={zip} onChange={props.onChange} />
  //       </FormGroup>
  //     </div>
  //     <div className='col-md-8 col-12'>
  //       <FormGroup>
  //         <Label for='city'>Gemeente</Label>
  //         <Input required type='text' name='city' id='city' value={city} onChange={props.onChange} />
  //       </FormGroup>
  //     </div>
  //     <div className='col-12'>
  //       <FormGroup>
  //         <Label for='countryId'>Land</Label>
  //         <Input type='select' name='countryId' id='countryId' value={countryId} onChange={props.onChange}>
  //           <option value='BE'>België</option>
  //         </Input>
  //       </FormGroup>
  //     </div>
  //   </div>
  // )
}

AddressField.propTypes = {
  onChange: PropTypes.func,
  address: PropTypes.object,
}



// WEBPACK FOOTER //
// ./src/components/Form/AddressField/AddressField.js